import { TuitionFeePrice, TuitionFeeGroupHeadFee } from '@/plugins/api'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    search: [],
    tuitionFeePrices: {},
    price: {},
    pageText: '',
    itemsPerPage: 5,
    SearchParams: {},
    totalItems: 0,
    loading: true
  },
  actions: {
    async createTuitionFeePrice({ commit }, payload) {
      try {
        commit('addPrice', await TuitionFeeGroupHeadFee.createPrice(payload))
        alert.addSuccess('kỳ đóng')
      } catch (error) {
        alert.addError(error)
      }
    },
    async getPriceById({ commit }, payload) {
      try {
        commit('getPriceById', await TuitionFeePrice.fetchOne(payload))
      } catch (error) {}
    },
    getPriceByIdIndepentdent(_, id) {
      return TuitionFeePrice.fetchOne(id)
    },
    async updatePrice({ commit }, payload) {
      try {
        commit('updatePrice', await TuitionFeePrice.update(payload.id, payload.price))
        alert.updateSuccess()
      } catch (error) {
        alert.updateError()
      }
    },
    async updatePriceIndependent(_, payload) {
      try {
        await TuitionFeePrice.update(payload.id, payload.price)
        alert.updateSuccess()
        return true
      } catch {
        alert.updateError()
        return false
      }
    },
    async deletePrice({ commit }, payload) {
      try {
        commit(
          'deletePrice',
          await TuitionFeeGroupHeadFee.removePrice(payload.groupHeadFeeId, { priceId: payload.idPrice })
        )
      } catch (error) {}
    },
    async setTuitionFeePrice({ commit }, id) {
      try {
        let groupHeadFee = await TuitionFeeGroupHeadFee.fetchOne(id)
        let tuitionFeePrices = groupHeadFee.prices
        commit('setTuitionFeePrices', {
          tuitionFeePrices
        })
        commit('changeState', { loading: false })
      } catch (error) {
        commit('changeState', { loading: true })
      }
    }
  },
  mutations: {
    setHeadFees(state, headFees) {
      state.headFees = headFees
    },
    getPriceById(state, price) {
      state.price = price
    },
    updatePrice(state, price) {
      state.tuitionFeePrices = state.tuitionFeePrices.map(item => (item.id === price.id ? price : item))
    },
    deletePrice(state, headFeeGroup) {
      state.tuitionFeePrices = headFeeGroup.prices
    },
    addPrice(state, price) {
      state.tuitionFeePrices = price.prices
    },
    setTuitionFeePrices(state, tuitionFeePrices) {
      state.tuitionFeePrices = tuitionFeePrices.tuitionFeePrices
    }
  }
}
